import { useState, useEffect } from 'react';
import { getCurrentStore } from '../helpers/userHelper';
import isLogged from "../services/isLogged";
import {getUser} from "../services/loginServices";

export default function useFindUser() {

    const [user, setUser] = useState(null)
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        let isMounted = true;
        async function findUser() {
            try{
                const response = await isLogged()
                if(response){
                    const res = await getUser()
                    let current_store = await getCurrentStore(res)
                    let warehouse_ids = res.warehouses ? res.warehouses.map(warehouse => warehouse.id) : []
                    if (isMounted) {
                        setUser({
                            ...res,
                            isLogged: true,
                            current_store: current_store,
                            warehouse_ids: warehouse_ids
                        })
                    }
                } else {
                    if (isMounted) {
                        setUser({
                            isLogged: false
                        })
                    }
                }
                if (isMounted) {
                    setIsLoading(false)
                }
            } catch (e){
                if (isMounted) {
                    setIsLoading(false)
                }
            }
        }
        findUser();
        return () => {
            isMounted = false;
        }
    }, [])

    return {
        user,
        setUser,
        isLoading
    }
}